export const SourceControlGridConfig = {
    columns: [
      {
        name: "Source Control Name",
        fieldName: "sourceControlName",
        allowShort: false,
        colStyle: {
          width: "100%",
        //   textAlign: "left",
        },
      },
     
    ],
  }
  